import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class SearchWorkflows extends Component {

constructor(props)
{
	//props[userId] = 227;
	console.log(props);
	super(props);

}

state =
{
		workflowsObject: {},
		workflows: []
};

componentDidMount()

{

	this.handleOnLoad();

}

handleOnLoad = () => {

	//`${global.config.apiServicesUrl}/workflows?filter[where][createUser][eq]=${this.props.userId}`
	let url = `${global.config.apiServicesUrl}/workflows?filter[where][createUser][eq]=${this.props.userId}`;
  axios.get(url).then(res => {
  const workflows = res.data;
  console.log(workflows);
  this.setState({ workflows : res.data });
	});
}

render(){

return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
						<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Workflows
														</h3>
														<input class="form-control input-xlarge col-sm-6" placeholder="Filter" />&nbsp;
														<a href="create-workflow" class="btn btn-success">Create Workflow</a>&nbsp;
							</div>

	<table class="oux_table table table-striped table-bordered table-hover" id="list" border="1" var="item" rows="20"  value="#{ombCustomerForm.searchResults }">

			<thead>
				<tr>
					<th scope = "col">Id</th>
					<th scope = "col">Name</th>
					<th scope = "col">Description</th>
					<th scope = "col">Actions</th>
				</tr>
			</thead>

			<tbody>

				{this.state.workflows.map( ( {workflowId, workflowName, description, statusCode, workflowTypCode} ) => {

					return	<tr>

							
							<td><Link  to={{ pathname: "/manage-workflow", search : `?id=${workflowId}` }}>{workflowId}</Link></td>
							<td><Link  to={{ pathname: "/manage-workflow", search : `?id=${workflowId}` }}>{workflowName}</Link></td>
							<td><Link  to={{ pathname: "/manage-workflow", search : `?id=${workflowId}` }}>{description}</Link></td>
							<td>

										<button class="btn btn-danger btn-sm">Delete</button>
							</td>
						</tr>


				})
			}

			</tbody>


		</table>
		
						</div>		
					</div>
	            </div>	
            	</div>
            
			</div>
			</div>
			



);
}
}

